import React, { useState, useEffect } from "react";
import { getWizardState, updateAccountView } from "../../utils/wizardStorage";
import { CreateAccountWizard, ForgotPasswordWizard, LoginWizard } from "../../components/accountCreation";

interface AccountStepProps {
    onNext: () => void;
    onBack: () => void;
    onCreate: () => void;
}

export enum AccountView {
    Login = "login",
    CreateAccount = "create",
    ForgotPassword = "forgot",
}

export const AccountStep: React.FC<AccountStepProps> = ({ onNext, onCreate, onBack }) => {
    const [currentView, setCurrentView] = useState<AccountView>(AccountView.Login);

    useEffect(() => {
        const savedState = getWizardState();
        if (savedState.accountView && Object.values(AccountView).includes(savedState.accountView as AccountView)) {
            setCurrentView(savedState.accountView as AccountView);
        }
    }, []);

    const changeView = (newView: AccountView) => {
        setCurrentView(newView);
        updateAccountView(newView);
    };

    const handleLoginSuccess = () => {
        updateAccountView("");
        onNext();
    };

    const handleCreateAccountSuccess = () => {
        updateAccountView("");
        onCreate();
    };

    const handleForgotPasswordSuccess = () => {
        changeView(AccountView.Login);
    };

    const renderCurrentView = () => {
        switch (currentView) {
            case AccountView.Login:
                return <LoginWizard onSuccess={handleLoginSuccess} onCreateAccountClick={() => changeView(AccountView.CreateAccount)} onForgotPasswordClick={() => changeView(AccountView.ForgotPassword)} />;
            case AccountView.CreateAccount:
                return <CreateAccountWizard onSuccess={handleCreateAccountSuccess} onBackToLoginClick={() => changeView(AccountView.Login)} />;
            case AccountView.ForgotPassword:
                return <ForgotPasswordWizard onSuccess={handleForgotPasswordSuccess} onBackToLoginClick={() => changeView(AccountView.Login)} />;
            default:
                return <LoginWizard onSuccess={handleLoginSuccess} onCreateAccountClick={() => changeView(AccountView.CreateAccount)} onForgotPasswordClick={() => changeView(AccountView.ForgotPassword)} />;
        }
    };

    return (
        <div className="max-w-md mx-auto">
            {renderCurrentView()}
            {currentView === AccountView.Login && (
                <div className="mt-6 text-center">
                    <button onClick={onBack} className="text-gray-500 hover:text-gray-700 text-sm flex items-center mx-auto">
                        ← Back to welcome
                    </button>
                </div>
            )}
        </div>
    );
};
